import moment, { Moment, MomentInput, unitOfTime } from "moment";
import { IRedlineableField } from "work/entities/proposal/redlining/field-redline";

export default class Date implements IRedlineableField {
  private readonly _value: Moment;

  constructor(value?: Moment) {
    this._value = value ?? moment();
  }

  public get isEmpty(): boolean {
    return false;
  }

  get value(): Moment {
    return this._value;
  }

  get isValid(): boolean {
    return this._value.isValid();
  }

  isAfter(other: Date, granularity?: unitOfTime.StartOf): boolean {
    return this._value.isAfter(
      other._value,
      granularity
    );
  }

  isEqualTo(other: Date | null | undefined): boolean {
    return this.isSame(other);
  }

  toString(format?: string | undefined): string {
    return this._value.format(format ?? 'MM/DD/YYYY');
  }

  isSame(other?: Date | null): boolean {
    if (!other) {
      return false;
    }
    return this._value.isSame(
      other._value,
      'minute'
    );
  }

  toISOString(): string {
    return this._value.toISOString();
  }

  format(format: string): string {
    return this._value.format(format);
  }

  public clone(): Date {
    return new Date(this._value);
  }

  public static fromJSON(obj: MomentInput | boolean): Date | null {
    if (!obj) return null;
    if (typeof obj === "boolean") return null;
    return new Date(moment(obj));
  }

  public fromJSON(obj: MomentInput | boolean): Date | null {
    return Date.fromJSON(obj);
  }

  public toJSON(): string {
    return this._value.toISOString();
  }

  public static get Prototype(): Date {
    return new Date();
  }
}